import { createSelector } from 'reselect'
import { AppState } from 'store/reducers'

/**
 *
 * @param state - the application state
 * @returns TemplatesReducer - the current punchCards reducer
 */
export const selectTemplatesReducer = (state: AppState) => state.templates

/**
 * Gets the templates array from the punchCard reducer
 */
export const selectTemplates = createSelector(
  selectTemplatesReducer,
  templatesState => templatesState.data,
)

/**
 * Gets the meta from the templates reducer
 */

export const selectTemplatesMeta = createSelector(
  selectTemplatesReducer,
  templatesState => templatesState.meta,
)

/**
 * Gets the isFetching flag from the templates reducer
 */
export const selectTemplatesIsFetching = createSelector(
  selectTemplatesReducer,
  templatesState => templatesState.isFetching,
)

/**
 * Gets the error from the templates reducer
 */
export const selectTemplatesError = createSelector(
  selectTemplatesReducer,
  templatesState => templatesState.error,
)
